<template>
  <v-dialog
    v-model="isShowModal"
    max-width="640px"
    persistent>
    <v-card>
      <material-card
        :title="$t('evoucher.voucherPrintPublishing')"
        tile
        color="green"
        full-width
      >
        <v-container grid-list-xl>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation>
            <div>
              <div v-if="voucherSelected.length > 0">
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm4
                    md4>
                    <v-text-field
                      v-model="voucherSelected.length"
                      :label="$t('evoucher.quantity')"
                      :name="$t('evoucher.quantity')"
                      disabled
                      type="text"
                    />
                  </v-flex>
                  <!-- Total price format -->
                  <v-flex
                    xs12
                    sm4
                    md4>
                    <v-text-field
                      v-model="totalPriceFormat"
                      :label="$t('workpieceDetail.totalPrice')"
                      :name="$t('workpieceDetail.totalPrice')"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout
                  row
                  wrap>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-autocomplete
                      :rules="[ruleRequiredValue]"
                      v-model="workpieceList.id"
                      :items="workpieceList.data"
                      :label="forConasi ? $t('assignVoucher.selectTheWorkPieceCode') : $t('assignVoucher.selectVoucher')"
                      clearable
                      class="required"
                      @change="onWorkpieceChange"
                    >
                      <template v-slot:item="data">
                        <span>{{ data.item.text }} <span class="grey--text font-small">[{{ data.item.code }}]</span></span>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- Prefix and suffix -->
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-autocomplete
                      v-if="forConasi"
                      :rules="[ruleRequiredValue]"
                      v-model="issuanceId"
                      :items="issuanceList"
                      :label="$t('assignVoucher.chooseIssuance')"
                      clearable
                      type="text"
                      class="required"
                      @change="onChangeIssuance"
                    >
                      <template
                        slot="selection"
                        slot-scope="data">
                        {{ concatSuffixPrefix(data.item) }}
                      </template>
                      <template
                        slot="item"
                        slot-scope="data">
                        {{ concatSuffixPrefix(data.item) }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- Voucher available quantity -->
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="quantityVoucherAvailableOfEntity"
                      :label="$t('evoucher.numberOfVouchersAvailable')"
                      :name="$t('evoucher.numberOfVouchersAvailable')"
                      disabled
                      type="number"
                    />
                  </v-flex>
                  <!-- Voucher quantity -->
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      :rules="[
                        ruleRequiredValue,
                        ruleMustGreaterThanZero,
                        ruleMustLessThanAvailableEVoucher,
                      ]"
                      v-model="quantityAssign"
                      :label="$t('evoucher.quantityToAssign')"
                      :name="$t('evoucher.quantityToAssign')"
                      :max="quantityVoucherAvailableOfEntity"
                      :min="0"
                      type="number"
                      class="required"
                      @input="onQuantityAssignChange"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="priceFormat"
                      :label="voucherValueType == VoucherValue.PRICE ? $t('infoVoucher.unitPrice') : $t('evoucher.discountPrice') + ' %'"
                      :name="voucherValueType == VoucherValue.PRICE ? $t('infoVoucher.unitPrice') : $t('evoucher.discountPrice') + ' %'"
                      disabled
                    />
                  </v-flex>
                  <!-- Total price format -->
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="totalPriceFormat"
                      :label="$t('workpieceDetail.totalPrice')"
                      :name="$t('workpieceDetail.totalPrice')"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-form>
        </v-container>
      </material-card>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          color="error darken-1"
          @click="onCloseModal"
        >{{ $t("common.close") }}
        </v-btn>
        <v-btn
          v-if="voucherSelected.length == 0"
          :disabled="!workpieceList.id"
          small
          color="warning darken-1"
          @click="onPreviewPrintVoucher"
        >{{ $t('evoucher.issuance.previewPrint') }}
        </v-btn>
        <v-btn
          :loading="isLoading"
          :disabled="!workpieceList.id"
          small
          color="success darken-1"
          @click="onConfirm"
        >{{ $t("common.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <snack-bar
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    />
    <previewPrintVoucher ref="previewPrintVoucher" />
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { FOR_CONASI_TARGET } from 'utils/constants'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
import validationRules from 'utils/validationRules'
import EntityType from 'enum/entityType'
import VoucherValue from 'enum/voucherValue'
import PreviewPrintVoucher from 'Components/PreviewPrintVoucherModal'
import moment from 'moment'
export default {
  components: {
    PreviewPrintVoucher,
    // EVoucherPreviewModal
  },
  data () {
    return {
      valid: false,
      isLoading: false,
      isShowModal: false,
      workpieceList: {
        data: [],
        id: null
      },
      quantityAssign: 0,
      quantityVoucherAvailableOfEntity: 0,
      voucherSelected: [],
      price: 0,
      priceFormat: 0,
      totalPriceFormat: 0,
      issuanceId: null,
      issuanceList: [],
      // eslint-disable-next-line no-unneeded-ternary
      forConasi: FOR_CONASI_TARGET,
      VoucherValue: VoucherValue,
      voucherValueType: VoucherValue.PRICE,
      printTemplateId: null,
    }
  },
  computed: {
    ...mapGetters([
      'GET_CURRENT_ACCOUNT',
      'GET_SNACK_BAR',
      'QUANTITY_VOUCHER_AVAILABLE_OF_ENTITY_DATA',
      'ISSUANCE_OF_VOUCHER_ALREADY_EXIST_DATA',
      'GET_ISSUANCE_LIST_DATA'
    ])
  },
  watch: {
    QUANTITY_VOUCHER_AVAILABLE_OF_ENTITY_DATA () {
      let data = this.QUANTITY_VOUCHER_AVAILABLE_OF_ENTITY_DATA
      this.quantityVoucherAvailableOfEntity = data.quantity_voucher_available
        ? data.quantity_voucher_available
        : 0
      this.price = data.unit_price
      this.priceFormat = functionUtils.convertFormatNumberToMoney(this.price)
      this.totalPriceFormat = functionUtils.convertFormatNumberToMoney(this.price * this.quantityAssign)
    },
    ISSUANCE_OF_VOUCHER_ALREADY_EXIST_DATA () {
      let data = this.ISSUANCE_OF_VOUCHER_ALREADY_EXIST_DATA
      this.workpieceList.data = []
      for (let i = 0, size = data.length; i < size; i++) {
        let obj = {
          value: data[i].id,
          text: data[i].name,
          type: data[i].type,
          isPersistentCode: data[i].is_persistent_code,
          isHidePrice: data[i].is_hide_price,
          description: data[i].description,
          conditionsOfUse: data[i].conditions_of_use,
          details: data[i].details,
          expiredDate: data[i].end_date,
          supplierImage: data[i].owner.image_url,
          providedBy: data[i].owner.name,
          hotline: data[i].owner.phone,
          website: data[i].owner.website,
          supplierId: data[i].owner.id,
          code: data[i].code,
          price: data[i].value,
          status: data[i].status,
          issuanceImage: data[i].image_url,
          usageSites: data[i].usage_sites,
          usageDuration: data[i].voucher_usage_duration,
          usageEndDate: !functionUtils.isEmptyString(data[i].voucher_usage_end_date)
            ? moment(data[i].voucher_usage_end_date).format('YYYY-MM-DD') : null
        }
        this.workpieceList.data.push(obj)
      }
      // Set issuance type value
      let workpieceSelected = this.workpieceList.data.filter(element => {
        return element.value === this.workpieceList.id
      })
      this.voucherValueType = workpieceSelected.length > 0 ? workpieceSelected[0].type : VoucherValue.PRICE
    },
    GET_ISSUANCE_LIST_DATA () {
      let data = this.GET_ISSUANCE_LIST_DATA
      this.issuanceList = []
      this.issuanceId = null
      for (let i = 0, size = data.length; i < size; i++) {
        let obj = {
          value: data[i].id,
          prefix: data[i].prefix,
          suffix: data[i].suffix,
          distributeEndDate: data[i].distribute_end_date
        }
        this.issuanceList.push(obj)
      }
    }
  },
  created () {},
  methods: {
    /**
     * Get prefix suffix
     */
    getIssuanceList: function (workpieceId) {
      let filter = {
        params: {
          workpieceId: workpieceId
        }
      }
      this.GET_ISSUANCE_LIST(filter)
    },
    /**
     * Prefix suffix change
     */
    onChangeIssuance: function () {
      this.getQuantityEVoucherAvailableOfEntity(this.workpieceList.id)
    },
    /**
     * Quantity assign change
     */
    onQuantityAssignChange: function () {
      this.totalPriceFormat = functionUtils.convertFormatNumberToMoney(this.price * this.quantityAssign)
    },
    concatSuffixPrefix: function (suffixPrefix) {
      return functionUtils.concatSuffixPrefix(suffixPrefix)
    },
    // Required value
    ruleRequiredValue (value) {
      return validationRules.ruleRequiredValue(value)
    },
    // Not greater than remain e voucher
    ruleMustLessThanAvailableEVoucher (value) {
      return validationRules.ruleMustLessThanOrEqual(value, this.quantityVoucherAvailableOfEntity)
    },
    // Not greater one hundred
    ruleMustLessThanOneHundred (value) {
      return validationRules.ruleMustLessThan(value, 100)
    },
    ruleLengthMustLessThan (text) {
      return validationRules.ruleLengthMustLessThan(text, 150)
    },
    // Greater than zero
    ruleMustGreaterThanZero (value) {
      return validationRules.ruleMustGreaterThan(value, 0)
    },
    ruleMustNotLessThanZero (value) {
      return validationRules.ruleMustGreaterThanOrEqual(value, 0)
    },
    ruleValidPhoneOrEmail (value) {
      return validationRules.ruleValidPhoneOrEmail(value)
    },
    /**
     * Get e voucher issuance list by entity
     */
    getEVoucherIssuanceListByEntity: function () {
      this.quantityAssign = 0
      this.quantityVoucherAvailableOfEntity = 0
      this.workpieceList.id = null
      let filter = {
        params: {
          isAssignForCustomer: false
        }
      }
      this.GET_ISSUANCE_OF_VOUCHER_ALREADY_EXIST_LIST(filter)
    },
    /**
     * Get quantity e voucher available of entity
     */
    getQuantityEVoucherAvailableOfEntity: function (workpieceId) {
      let entityType = sessionStorage.getItem('entityType')
      let transactionType = (entityType === EntityType.SUPPLIER) ? EntityType.AGENT : EntityType.CUSTOMER
      let filter = {}
      if (!functionUtils.isNull(workpieceId)) {
        filter = {
          params: {
            workpieceId: workpieceId,
            transactionType: transactionType,
            issuanceId: this.issuanceId
          }
        }
      } else {
        filter = {
          params: {
            transactionType: transactionType,
            issuanceId: this.issuanceId
          }
        }
      }
      this.GET_QUANTITY_VOUCHER_AVAILABLE_OF_ENTITY(filter)
    },
    /**
     * Change e voucher issuance
     */
    onWorkpieceChange: function (workpieceId) {
      let workpieceSelected = this.workpieceList.data.filter(element => {
        return element.value === workpieceId
      })
      if (workpieceSelected.length > 0) {
        this.voucherValueType = workpieceSelected[0].type
      } else {
        this.voucherValueType = VoucherValue.PRICE
      }
      this.getQuantityEVoucherAvailableOfEntity(workpieceId)
      this.getIssuanceList(workpieceId)
      this.quantityAssign = 0
    },
    /**
     * Preview print voucher
     */
    onPreviewPrintVoucher: function () {
      let workpieceSelected = this.workpieceList.data.filter(element => {
        return element.value === this.workpieceList.id
      })
      let agentImage = functionUtils.isAgentEntity() ? sessionStorage.getItem('entityImage') : null
      let distributeBy = sessionStorage.getItem('entityName')

      let voucherInfo = {
        providedBy: workpieceSelected.length > 0 ? workpieceSelected[0].providedBy : '',
        hotline: workpieceSelected.length > 0 ? workpieceSelected[0].hotline : '',
        website: workpieceSelected.length > 0 ? workpieceSelected[0].website : '',
        distributeBy: distributeBy,
        name: workpieceSelected.length > 0 ? workpieceSelected[0].text : null,
        price: this.price,
        isHidePrice: workpieceSelected.length > 0 ? workpieceSelected[0].isHidePrice : false,
        type: this.voucherValueType,
        expiredDate: workpieceSelected.length > 0 ? workpieceSelected[0].expiredDate : null,
        description: workpieceSelected.length > 0 ? workpieceSelected[0].description : '',
        conditionsOfUse: workpieceSelected.length > 0 ? workpieceSelected[0].conditionsOfUse : '',
        details: workpieceSelected.length > 0 ? workpieceSelected[0].details : null,
        logoSupplier: workpieceSelected.length > 0 ? workpieceSelected[0].supplierImage : null,
        logoAgent: agentImage
      }

      this.$refs.previewPrintVoucher.onShowModal(voucherInfo, this.printTemplateId)
    },
    /**
     * Check null
     */
    isNull: function (data) {
      return functionUtils.isNull(data)
    },
    /**
     * Set default data
     */
    setDefaultData: function () {
      this.isShowModal = false
      this.quantityAssign = 0
      this.quantityVoucherAvailableOfEntity = 0
      this.workpieceList.id = null
      this.price = 0
      this.priceFormat = 0
      this.totalPriceFormat = 0
      this.issuanceId = null
    },
    onShowModal: function (voucherSelected) {
      // Reset the form validation state
      this.$refs.form.resetValidation()
      this.isShowModal = true
      this.printTemplateId = null
      this.quantityAssign = 0
      this.quantityVoucherAvailableOfEntity = 0
      this.workpieceList.id = null
      this.price = 0
      this.priceFormat = 0
      this.totalPriceFormat = 0
      this.issuanceId = null
      this.issuanceList = []
      this.voucherSelected = voucherSelected

      if (this.voucherSelected.length > 0) {
        let totalPrice = 0
        for (let i = 0, size = this.voucherSelected.length; i < size; i++) {
          totalPrice += this.voucherSelected[i].price
        }
        // this.priceFormat = functionUtils.convertFormatNumberToMoney(this.price)
        this.totalPriceFormat = functionUtils.convertFormatNumberToMoney(totalPrice)
      } else {
        this.getEVoucherIssuanceListByEntity()
      }
    },
    /**
     * Close modal
     */
    onCloseModal: function () {
      this.setDefaultData()
    },
    /**
     * Confirm
     */
    onConfirm: function () {
      if (this.$refs.form.validate()) {
        let filter = {
          quantity: this.quantityAssign,
          issuanceId: this.issuanceId,
          workpieceId: this.workpieceList.id,
          voucherSelected: this.voucherSelected
        }
        this.isLoading = true
        this.PUBLISH_PRINT_VOUCHERS(filter)
          .then(
            function (res) {
              this.isLoading = false
              this.setDefaultData()
              this.ON_SHOW_TOAST({
                message: this.$t('server.common.successed'),
                styleType: ToastType.SUCCESS
              })
            }.bind(this)
          )
          .catch(
            function (error) {
              this.isLoading = false
              this.ON_SHOW_TOAST({
                message: this.$t(functionUtils.errorResponse(error.response)),
                styleType: ToastType.ERROR
              })
            }.bind(this)
          )
      }
    },
    /**
     * Assign for customer change
     */
    assignForCustomerChange: function () {
      this.getEVoucherIssuanceListByEntity()
    },
    /**
     * Check has action
     */
    hasAction: function (metaAction) {
      return functionUtils.hasAction(this.GET_CURRENT_ACCOUNT, metaAction)
    },
    getRandomCode: function (length) {
      return functionUtils.randomString(length)
    },
    ...mapActions([
      'ON_SHOW_TOAST',
      'PUBLISH_PRINT_VOUCHERS',
      'GET_QUANTITY_VOUCHER_AVAILABLE_OF_ENTITY',
      'GET_ISSUANCE_OF_VOUCHER_ALREADY_EXIST_LIST',
      'GET_ISSUANCE_LIST'
    ])
  }
}
</script>
<style lang="scss" scoped>
.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.v-card {
  margin-bottom: 0px !important;
  margin-top: 21px !important;
}
:deep(.required label::after) {
  content: " *";
  color: red;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>
